'use strict';

module.exports = {
  'name': 'kron',
  'category': 'Matrix',
  'syntax': ['kron(x, y)'],
  'description': 'Calculates the kronecker product of 2 matrices or vectors.',
  'examples': ['kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])', 'kron([1,1], [2,3,4])'],
  'seealso': ['multiply', 'dot', 'cross']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/matrix/kron.js
// module id = 1443
// module chunks = 3